/**
 * Wizard step 3 — paste the model's JSON. One clear error line on a bad or
 * mismatched payload; success decomposes into the review items.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useState, type FC } from 'react';
import { AlertCircle, ClipboardPaste } from 'lucide-react';

import { Button } from '@/components/ui';

import type { AiWizardState } from '../use-ai-wizard';

const PasteStep: FC<{ wizard: AiWizardState }> = ({ wizard }) => {
  const [text, setText] = useState('');
  return (
    <div className="space-y-3">
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder='Paste the model’s JSON here — the whole {"kind":"tp-flow-optimizer", …} block.'
        rows={10}
        autoFocus
        className="w-full resize-none rounded-md border border-border bg-background p-2 font-mono text-[11px] leading-snug"
      />
      {wizard.pasteError ? (
        <p className="flex items-center gap-1.5 text-xs text-destructive">
          <AlertCircle className="h-3.5 w-3.5 shrink-0" aria-hidden />
          {wizard.pasteError}
        </p>
      ) : null}
      <div className="flex items-center justify-between">
        <Button variant="ghost" size="sm" onClick={() => wizard.setStep('prompt')}>
          ← Back to prompt
        </Button>
        <Button size="sm" disabled={!text.trim()} onClick={() => wizard.reviewPaste(text)}>
          <ClipboardPaste className="mr-1 h-3.5 w-3.5" aria-hidden />
          Review items
        </Button>
      </div>
    </div>
  );
};

export default PasteStep;
